/** @flow */
import * as React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { translate } from 'react-i18next';

import { Colors } from '../../../themes';
import type { StepInMinutes } from '../../../domain/reach';

export const getIntervals = (t: any) => {
  return {
    '5': t('time.nbMinute', { count: 5 }),
    '15': t('time.nbMinute', { count: 15 }),
    '30': t('time.nbMinute', { count: 30 }),
    '60': t('time.nbHour', { count: 1 }),
  };
};

function TimeIntervalChooser(props: { interval: StepInMinutes, onChange: (interval: StepInMinutes) => void, t: any }) {
  const INTERVALS = getIntervals(props.t);

  return (
    <SelectField
      value={props.interval}
      style={{ display: 'block', width: '150px' }}
      underlineStyle={{ height: 1 }}
      selectedMenuItemStyle={{
        color: Colors.primary,
        fontSize: '1rem',
      }}
      labelStyle={{
        color: Colors.primaryText,
        fontSize: '1rem',
      }}
      menuItemStyle={{
        color: Colors.primaryText,
        fontSize: '1.1rem',
      }}
      onChange={(e, i, value) => props.onChange(value)}
    >
      {Object.keys(INTERVALS).map(key =>
        <MenuItem key={key} value={parseInt(key, 10)} primaryText={INTERVALS[key]} />,
      )}
    </SelectField>
  );
}

export default translate()(TimeIntervalChooser);



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/components/TimeIntervalChooser.js